import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="A" transform="translate(11.000000, 5.000000)">
        <path
          d="M36.6,30.3 L42.6,30.3 L52,61 L46.7,61 L44.7,54.6 L34.5,54.6 L32.5,61 L27.2,61 Z M39.6,37.9 L35.9,50 L43.3,50 Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
